// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import ReportSearchController from "./reportSearch_controller"
import ReportFilterChipsController from "./reportFilterChips_controller"
import ProjectIncomeStatementController from "./projectIncomeStatement_controller"

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
// The context loader preserves case; expose the usual HTML identifiers.
application.register("report-search", ReportSearchController)
application.register("report-filter-chips", ReportFilterChipsController)
application.register("project-income-statement", ProjectIncomeStatementController)
